import { render, staticRenderFns } from "./AddSystemInformation.vue?vue&type=template&id=1638c708"
import script from "./AddSystemInformation.vue?vue&type=script&lang=ts"
export * from "./AddSystemInformation.vue?vue&type=script&lang=ts"
import style0 from "./AddSystemInformation.vue?vue&type=style&index=0&id=1638c708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports